import http from './http';
import { listResource } from './listResource';

// Clients
// Listar clientes/participantes
export async function listClients(options = {}) {
  return listResource('/participants', options);
}

// Obtener una cliente/participante por su ID
export async function getClientById(id) {
  const res = await http.get(`/participants/${id}`);
  return res.data?.data ?? res.data;
}

// Crear una nueva cliente/participante
export async function createClient(payload) {
  const res = await http.post('/participants', payload);
  return res.data?.data ?? res.data;
}

// Actualizar una cliente/participante existente
export async function updateClient(id, payload) {
  const res = await http.put(`/participants/${id}`, payload);
  return res.data?.data ?? res.data;
}

// Eliminar cliente/participante
export const deleteClient = (id) => http.delete(`/participants/${id}`);

// Subir archivo de imagen para cliente/participante
export async function uploadClientMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/participants', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

/**
 * Activar/Desactivar cliene
 */
export const updateClientStatus = (id, status) =>
  // eslint-disable-next-line camelcase
  http.patch(`/participants/status/${id}`, { status: status });


// Verificar si un título ya existe
export async function checkClientEmailExists(title, excludeId = null) {
  try {
    const { items } = await listClients({ search: title });
    const exists = items?.some(
      (Client) =>
        Client.email?.toLowerCase() === title?.toLowerCase() &&
        Client.id !== excludeId
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar título:', error);
    return false;
  }
}

export async function getClientSubscriptions(id) {
  const res = await http.get(`/participants/${id}/history/subscriptions`);
  return res.data?.data ?? res.data;
}

export async function getClientTokens(id) {
  const res = await http.get(`/participants/${id}/history/tokens`);
  return res.data?.data ?? res.data;
}

export async function getClientCompetitions(id) {
  const res = await http.get(`/participants/${id}/history/competitions`);
  return res.data?.data ?? res.data;
}

export async function getClientFullHistory(id) {
  const res = await http.get(`/participants/${id}/history`);
  return res.data?.data ?? res.data;
}
